import angular from 'angular';
import AutocompleteController from './autocomplete.controller';

export const AutocompleteComponent = {
  selector: 'abAutocomplete',
  bindings: {
    customModel: '=',
    options: '<',
    placeholder: '@?',
    required: '=?',
  },
  controller: AutocompleteController,
  template: /* html */ `
    <div class="ab-autocomplete input-wrap select">
      <input ng-model="$ctrl.customModel" type="text" ng-focus="$ctrl.showOptions($event)" ng-click="$ctrl.showOptions($event)" placeholder="{{ $ctrl.placeholder }}" ng-required="$ctrl.required" />
      <label>{{ $ctrl.placeholder }}</label>
    </div>
  `,
};

export default angular.module('components.abAutocomplete', [])
  .component(AutocompleteComponent.selector, AutocompleteComponent)
  .name;
